/**
 * Initial color palettes data for the colorPalettes store.
 *
 * Standard palette is the default with 20 map-friendly colors.
 * Pink and Petrol palettes match the app's design system and can be imported.
 */
const initialColorPalettesData = [
  {
    name: 'Standard',
    isDefault: true,
    isActive: true,
    colors: [
      // Reds & Pinks
      { id: 1,  hex: '#DC2626', name: 'Red' },           // Tailwind red-600
      { id: 2,  hex: '#DB2777', name: 'Pink' },          // Tailwind pink-600
      { id: 3,  hex: '#E11D48', name: 'Rose' },          // Tailwind rose-600

      // Oranges & Yellows
      { id: 4,  hex: '#EA580C', name: 'Orange' },        // Tailwind orange-600
      { id: 5,  hex: '#D97706', name: 'Amber' },         // Tailwind amber-600
      { id: 6,  hex: '#CA8A04', name: 'Yellow' },        // Tailwind yellow-600

      // Greens (sophisticated, map-friendly)
      { id: 7,  hex: '#65A30D', name: 'Lime' },          // Tailwind lime-600
      { id: 8,  hex: '#16A34A', name: 'Green' },         // Tailwind green-600
      { id: 9,  hex: '#059669', name: 'Emerald' },       // Tailwind emerald-600
      { id: 10, hex: '#0D9488', name: 'Teal' },          // Tailwind teal-600

      // Blues & Cyans
      { id: 11, hex: '#0891B2', name: 'Cyan' },          // Tailwind cyan-600
      { id: 12, hex: '#0284C7', name: 'Sky' },           // Tailwind sky-600
      { id: 13, hex: '#2563EB', name: 'Blue' },          // Tailwind blue-600
      { id: 14, hex: '#4F46E5', name: 'Indigo' },        // Tailwind indigo-600

      // Purples & Violets
      { id: 15, hex: '#7C3AED', name: 'Violet' },        // Tailwind violet-600
      { id: 16, hex: '#9333EA', name: 'Purple' },        // Tailwind purple-600
      { id: 17, hex: '#C026D3', name: 'Fuchsia' },       // Tailwind fuchsia-600

      // Neutrals
      { id: 18, hex: '#57534E', name: 'Stone' },         // Tailwind stone-600
      { id: 19, hex: '#52525B', name: 'Zinc' },          // Tailwind zinc-600
      { id: 20, hex: '#475569', name: 'Slate' }          // Tailwind slate-600
    ],
    createdAt: Date.now()
  },
  {
    name: 'Pink',
    isDefault: false,
    isActive: false,
    colors: [
      // Primary colors from the app's design system (pink scale)
      { id: 1,  hex: '#FDF2F8', name: 'Pink 50' },       // Lightest
      { id: 2,  hex: '#FCE7F3', name: 'Pink 100' },
      { id: 3,  hex: '#FBCFE8', name: 'Pink 200' },
      { id: 4,  hex: '#F9A8D4', name: 'Pink 300' },
      { id: 5,  hex: '#F472B6', name: 'Pink 400' },
      { id: 6,  hex: '#EC4899', name: 'Pink 500' },      // Brand primary
      { id: 7,  hex: '#DB2777', name: 'Pink 600' },
      { id: 8,  hex: '#BE185D', name: 'Pink 700' },
      { id: 9,  hex: '#9D174D', name: 'Pink 800' },
      { id: 10, hex: '#831843', name: 'Pink 900' }       // Darkest
    ],
    createdAt: Date.now()
  },
  {
    name: 'Petrol',
    isDefault: false,
    isActive: false,
    colors: [
      // Secondary colors from the app's design system (petrol/blue scale)
      { id: 1,  hex: '#E8F4FA', name: 'Petrol 50' },     // Lightest
      { id: 2,  hex: '#B8E8FF', name: 'Petrol 100' },
      { id: 3,  hex: '#8CABBE', name: 'Petrol 200' },
      { id: 4,  hex: '#5D87A1', name: 'Petrol 300' },
      { id: 5,  hex: '#415A8B', name: 'Petrol 400' },
      { id: 6,  hex: '#146284', name: 'Petrol 500' },    // Brand secondary
      { id: 7,  hex: '#074369', name: 'Petrol 600' },
      { id: 8,  hex: '#053452', name: 'Petrol 700' },
      { id: 9,  hex: '#0A1929', name: 'Petrol 800' },
      { id: 10, hex: '#03045E', name: 'Petrol 900' }     // Darkest (navy)
    ],
    createdAt: Date.now()
  }
];

export default initialColorPalettesData;
